var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigTeaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4160_81571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 19H217V121H80V19Z",
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213 23H84V117H213V23ZM80 19V121H217V19H80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 88L223.428 98.335L201.727 126.907L179 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.129 102.753L234 122.457L228.271 130L201.4 110.297L207.129 102.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.863 82.0005L230.348 95.838L221.088 108.029L239.646 121.636L229.077 135.552L210.519 121.944L201.292 134.093L170.863 82.0005ZM209.713 116.393L228.271 130L234 122.457L215.442 108.849L223.428 98.3351L179 88.0002L201.727 126.907L209.713 116.393Z",
    fill: "#4C6170"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#FFB60A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4160_81571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(80 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTeaser);
export default __webpack_public_path__ + "static/media/big-teaser.c638e5c35eab5d4a9663a1d76e3766ff.svg";
export { ForwardRef as ReactComponent };